export default "__VITE_ASSET__FChbTSeb__"